import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import MyContext from '@/shared/contexts/AppContext';
import { AttendanceSheetsFilters } from './PerMonthFilters';
import { AttendanceSheetsModals } from './PerMonthModals';
import { AttendanceSheetsTable } from './PerMonthTable';
import { Link } from 'react-router-dom';
import { MassNotificationModal } from '../../components/ModalNotificacaoMassa';
import { useAttendanceSheets } from '../perMonth/usePerMonth';
import { useContext } from 'react';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';

export function AttendanceSheetsPerMonthPage() {
  const context = useContext(MyContext);
  if (!context)
    throw new Error('Contexto deve ser usado dentro de um Provedor.');

  const tableState = useDataTableState('estagiario.nome');
  const {
    mesBusca,
    setMesBusca,
    statusBusca,
    setStatusBusca,
    filtroResponsavel,
    setFiltroResponsavel,
    filtroEstagiario,
    setFiltroEstagiario,
    filtrosStatus,
    registros,
    handleBuscar,
    comFolha,
    setComFolha,
    responsaveis,
    estagiarios,
    permissaoCriarFolhas,
    isExecuting,
    handleCriarFolha,
    handleGenerateAttendanceSheetsForMonth,
    selectedItem,
    setSelectedItem,
    folhaSelecionada,
    setFolhaSelecionada,
    showModalCriarFolha,
    setShowModalCriarFolha,
    showModalCriarFolhas,
    setShowModalCriarFolhas,
    showModalNotificacaoIndividual,
    setShowModalNotificacaoIndividual,
    showModalNotificacoes,
    setShowModalNotificacoes,
    showModalResponsavel,
    setShowModalResponsavel,
    showModalAssinaturas,
    setShowModalAssinaturas,
    folhaParaAssinaturas,
    setFolhaParaAssinaturas,
    loaded,
  } = useAttendanceSheets(tableState);

  if (!loaded) return <Loading />;

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h3 className="pt-4">Folhas de Frequências</h3>
          <span className="blockquote-footer pb-4 text-end">
            Registros de faltas justificadas e presenças com horários de
            entrada e saída.
          </span>
        </div>

        <div className="col-md-4">
          <br />
          <Link
            className="btn btn-sm btn-outline-secondary float-end ms-4"
            to={Links.Auth_Logout}
            title="Sair do sistema"
          >
            Sair
          </Link>
          {context.state?.username && registros && registros.length > 0 && (
            <button
              type="button"
              className="btn btn-sm btn-outline-info me-4"
              title="Enviar notificações em massa."
              onClick={() => setShowModalNotificacoes(true)}
              disabled={registros!.length <= 0}
            >
              Notificações
            </button>
          )}
        </div>
      </div>
      <hr />

      <AttendanceSheetsFilters
        mesBusca={mesBusca}
        setMesBusca={setMesBusca}
        filtrosStatus={filtrosStatus}
        statusBusca={statusBusca}
        setStatusBusca={setStatusBusca}
        filtroResponsavel={filtroResponsavel}
        setFiltroResponsavel={setFiltroResponsavel}
        filtroEstagiario={filtroEstagiario}
        setFiltroEstagiario={setFiltroEstagiario}
        responsaveis={responsaveis}
        estagiarios={estagiarios}
        comFolha={comFolha}
        setComFolha={setComFolha}
        permissaoCriarFolhas={permissaoCriarFolhas}
        setShowModalCriarFolhas={setShowModalCriarFolhas}
        tableState={tableState}
      />

      {registros && (
        <AttendanceSheetsTable
          registros={registros}
          tableState={tableState}
          handleBuscar={handleBuscar}
          setSelectedItem={setSelectedItem}
          setShowModalCriarFolha={setShowModalCriarFolha}
          setFolhaSelecionada={setFolhaSelecionada}
          setShowModalResponsavel={setShowModalResponsavel}
          setShowModalNotificacaoIndividual={setShowModalNotificacaoIndividual}
          setFolhaParaAssinaturas={setFolhaParaAssinaturas}
          setShowModalAssinaturas={setShowModalAssinaturas}
        />
      )}

      <AttendanceSheetsModals
        folhaSelecionada={folhaSelecionada}
        selectedItem={selectedItem}
        showModalResponsavel={showModalResponsavel}
        setShowModalResponsavel={setShowModalResponsavel}
        showModalNotificacaoIndividual={showModalNotificacaoIndividual}
        setShowModalNotificacaoIndividual={setShowModalNotificacaoIndividual}
        showModalCriarFolha={showModalCriarFolha}
        setShowModalCriarFolha={setShowModalCriarFolha}
        showModalCriarFolhas={showModalCriarFolhas}
        setShowModalCriarFolhas={setShowModalCriarFolhas}
        showModalNotificacoes={showModalNotificacoes}
        setShowModalNotificacoes={setShowModalNotificacoes}
        isExecuting={isExecuting}
        handleCriarFolha={handleCriarFolha}
        handleGenerateAttendanceSheetsForMonth={
          handleGenerateAttendanceSheetsForMonth
        }
        registros={registros}
        mesBusca={mesBusca}
        showModalAssinaturas={showModalAssinaturas}
        setShowModalAssinaturas={setShowModalAssinaturas}
        folhaParaAssinaturas={folhaParaAssinaturas}
      />

      {registros && registros.length > 0 && (
        <MassNotificationModal
          isOpen={showModalNotificacoes}
          onClose={() => setShowModalNotificacoes(false)}
          registros={registros?.[0]}
        />
      )}
    </>
  );
}
